// extracted by mini-css-extract-plugin
export default {"field":"SplitCardElement_field__oo6-u","input":"SplitCardElement_input__rzOO9","row":"SplitCardElement_row__gsbu7"};